module.exports = __webpack_public_path__ + "static/media/person-thinking-svgrepo-com.aeb192e1.svg";